import TaxonomyItem from "features/taxonomy/components/TaxonomyItem";
import { useSelector } from "react-redux";
import { getTaxonomyColorData } from "utils/helpers";

export default function InsightType({ object, typeId, isEdit, handleRemove }) {
	const type = useSelector(({ libraries }) => libraries?.insightTypes?.getById(typeId || object?.id));

	if (!type) return null;

	const isUnlinkable = isEdit && handleRemove;

	const handleUnlink = (e) => {
		e?.stopPropagation();
		handleRemove(object.id);
	};

	const { color, backgroundColor } = getTaxonomyColorData({ entity: "insightType", colorCode: type?.colorCode });

	return (
		<div onClick={isUnlinkable ? handleUnlink : null}>
			<TaxonomyItem text={type?.name} backgroundColor={backgroundColor} color={color} isUnlinkable={isUnlinkable} />
		</div>
	);
}
